import { IAgent } from 'interfaces/agents';
import { Space, Tag, Typography } from 'antd';

const { Text } = Typography;

const SUPER_PERMISSION = '*:*:*';

interface GroupsColumnProps {
  permissions: string[];
  rolePermissions: string[];
  roles: IAgent['roles'];
}

export const GroupsColumn = ({
  permissions,
  rolePermissions,
  roles
}: GroupsColumnProps) => {
  // Access is granted from the agent's own permissions and from its groups
  // alike, so either origin can make someone a super admin.
  const isSuper = [...permissions, ...rolePermissions].includes(
    SUPER_PERMISSION
  );

  if (roles.length === 0 && !isSuper) {
    return <Text type="secondary">Sem grupo</Text>;
  }

  return (
    <Space size={[0, 4]} wrap>
      {isSuper && <Tag color="gold">Super admin</Tag>}

      {roles.map(role => (
        <Tag key={role.id}>{role.name}</Tag>
      ))}
    </Space>
  );
};
